import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Api} from "../api.service";
import {Observable} from "rxjs/Observable";
import {Company} from "../api/companies/api.models";
import {AuthenticationService} from "../authentication.service";
import {Permission} from "../api/permissions/api.models";

@Injectable()
export class CompaniesResolver implements Resolve<any> {
    constructor(private api: Api, private auth: AuthenticationService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Company[]> {
        return Observable.create((mainObservable) => {
            if (this.auth.canDoAny([Permission.COMPANIES_READ]) === false) {
                mainObservable.next([]);
                mainObservable.complete();
                return;
            }

            return this.api.companies().collection().toPromise().then(
                (result: any) => {
                    mainObservable.next(result);
                    mainObservable.complete();
                },
                (error: any) => {
                    mainObservable.error({message: error, ngNavigationCancelingError: true});
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/resolvers/companies.resolver.ts